import axios from 'axios';
import { useEffect, useState } from 'react';
import { Breadcrumb, Toast } from 'react-bootstrap';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useOperatorsState } from '../../services/OperatorsList';
import { useAuthState } from '../../services/auth';
import './cpe-details.scss';
import { DetailsCpe } from './details/DetailsCpe';
import { DevicesCpe } from './devices/DevicesCpe';
import { MobilesCpe } from './mobiles/MobilesCpe';
import { RoutersCpe } from './routers/RoutersCpe';
import { ThreatsByType } from './threats/Threats';
import { RouterActivity } from './routerActivity/RouterActivity';
import { DarkButton } from '../../components/operator-dashboard/dark-button/DarkButton';
import { useToast } from '../../services/ToastContext';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { WidgetBox } from '../../components/box-widget/WidgetBox';
import { RouterSettings } from './routerSettings/RouterSettings';
import {CustomPreviousIcon} from '../../components/table-widget/TableWidget'
import CallLogs from './Call Logs/CallLogs';
import {
  ArrowLeft,
  Clock,
  Globe,
  Info,
  LucideIcon,
  MonitorSmartphone,
  PhoneCall,
  Radar,
  Router,
  ShieldAlert,
  ShieldCheck,
  ShieldOff,
  SlidersHorizontal,
  Smartphone,
} from 'lucide-react';
import '../../design-system/index.css';

type Props = {
  darkMode: any;
  isActive: (link: string) => void;
};

interface CveData {
  cve_id: string;
  description: string;
  cvssVersion: string;
  score: number;
  source: string;
  published: string;
  required_action: string;
}

interface Port {
  timestamp: string;
  scan_id: String;
  hwaddr: string;
  hosts: [
    {
      address: string;
      latency: string;
      ports: [
        {
          id: number;
          protocol: string;
          service: {
            cve_list: [CveData];
            name: string;
            product: string;
            version: string;
            state: string;
          };
        }
      ];
      status: string;
    }
  ];
}

export const CpeDetails = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { operatorId, cpeId } = useParams();
  const { token, axiosInstance } = useAuthState();
  const [summaryData, setSummaryData] = useState<any>();
  const [mdmChartData, setMdmChartdata] = useState<any>();
  const { operatorList, loggedUserData } = useOperatorsState();
  const [emailList, setEmailList] = useState<string[]>([]);
  const [email, setEmail] = useState<string>('');
  const [showModal, setShowModal] = useState(false);
  const [showModalEmail, setShowModalEmail] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState('Details');
  const [emailSuccess, setEmailSuccess] = useState<boolean>(false);
  const [loading, isLoading] = useState(false);
  const [scanData, setScanData] = useState<Port>();
  const [isClicked, setIsClicked] = useState(false);
  const [cveData, setCveData] = useState<CveData | null>(null);
  const { showToastMessage } = useToast();
const [showActivity, setShowActivity] = useState(false);

  // const menuList = ['Details', 'Routers', 'Devices', 'Threats', 'Activity', 'Scan'];
  // const menuList = ['Details', 'Routers', 'Devices', 'Threats', 'Activity', 'Settings'];
    // const menuList = ['Details','Devices', 'Threats', 'Activity'];
const menuList = ['Details', 'Devices', 'Threats', 'Call Logs', ...(showActivity ? ['Activity'] : [])];

  // const toggleModal = () => {
  //   setShowModal(!showModal);
  // };
  // const toggleModalEmail = () => {
  //   setShowModalEmail(!showModalEmail);
  // };
  // const toggleAccount = () => {
  //   setShowAccount(!showAccount);
  // };



  const tabIcons: Record<string, LucideIcon> = {
    Details: Info,
    Routers: Router,
    Devices: MonitorSmartphone,
    Mobiles: Smartphone,
    Threats: ShieldAlert,
    Activity: Globe,
    Settings: SlidersHorizontal,
    Scan: Radar,
    'Call Logs': PhoneCall,
  };

  // Tab ids stay English (used for state/logic); labels are translated at render
  const tabLabelKeys: Record<string, string> = {
    Details: 'cpeDetails.tabs.details',
    Routers: 'cpeDetails.tabs.routers',
    Devices: 'cpeDetails.tabs.devices',
    Mobiles: 'cpeDetails.tabs.mobiles',
    Threats: 'cpeDetails.tabs.threats',
    Activity: 'cpeDetails.tabs.activity',
    Settings: 'cpeDetails.tabs.settings',
    Scan: 'cpeDetails.tabs.scan',
    'Call Logs': 'cpeDetails.tabs.callLogs',
  };




  
useEffect(() => {
  if (token) {
    fetchApi();
    mdmChart();
    checkActivityVisibility(); // check DNS visibility on load
  }

  if (summaryData?.data?.dateVerified === null) {
    setBackBtnText('cpeDetails.header.backToUnverifiedAccounts');
  } else {
    setBackBtnText('cpeDetails.header.backToAccounts');
  }
}, [token]);

// ✅ Function to check whether Activity tab should be visible
async function checkActivityVisibility() {
  try {
    const response = await axios.get(
      `/v2/op/master-operator/${operatorId}/fetch-retina-dns-visibility`
    );

    if (response?.data?.retinaDns !== undefined) {
      // 1 = visible, 0 = hidden
      setShowActivity(response.data.retinaDns === 1);
    } else {
      setShowActivity(false);
    }
  } catch (error) {
    console.error("Error fetching Retina DNS visibility:", error);
    setShowActivity(false);
  }
}

// ✅ Optional: Function to toggle visibility manually if needed later

  function handleAddEmail(event: any) {
    event.preventDefault();

    setEmailList([...emailList, email]);

    setEmail('');
  }

  // function handleDeleteEmail(index: number) {
  //   setEmailList((prevList) => prevList.filter((email, i) => i !== index));
  // }

  async function mdmChart() {
    const data = await axios.get(`/op/${cpeId}/endpoint`);
    setMdmChartdata(data.data);
  }

  async function fetchApi() {
    const data = await axios.get(`/op/${operatorId}/cpe/${cpeId}`);
    setSummaryData(data);
    setEmailSuccess(false);
  }

  function getTdValue(value: any) {
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{value}</Tooltip>}>
        <div>{value}</div>
      </OverlayTrigger>
    );
  }

  function handleMenuClick(menuName: string) {
    setSelectedMenu(menuName);
  }

  let hw_addr: string, ip_address: string, api_key: string;

  const scanResults = async (event: any) => {
    event.preventDefault();

    const getHw_Addr = await axios
      .get(`/v2/op/router/${operatorId}/port-scan?email=${summaryData?.registrant}`)
      .then((response) => {
        hw_addr = response.data['Device Address'];
        ip_address = response.data['IP Address'];
      })
      .catch((error) => {
        console.log(error);
      });

    if (hw_addr && ip_address) {
      const sendScan = await axios.post(`https://portcullis.blackdice.ai/v1/on-demand`, {
        hw_addr: hw_addr,
        ip_address: ip_address,
        api_key: '',
        scan_type: '',
        operator_id: Number(operatorId),
      });
    }
  };

  const getLatestResult = async () => {
    const getHw_Addr = await axios
      .get(`/v2/op/router/${cpeId}/port-scan`)
      .then((response) => {
        hw_addr = response.data['Device Address'];
        ip_address = response.data['IP Address'];
        api_key = 'FB8EhAhxx7otBQn7re';
        isLoading(true);
      })
      .catch((error) => {
        console.log(error);
      });
    const response = await axios
      .get(`https://portcullis.blackdice.ai/result?api_key=FB8EhAhxx7otBQn7re&hw_addr=${hw_addr}`)
      .then((response) => {
        setScanData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCve = (data: any) => {
    setIsClicked(true);
    setCveData(data);
    // console.log('CVE data:', data);
  };

  function formatDate(dateString: string) {
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = timePart.split(':');
    const formattedSeconds = seconds.split('.')[0];

    return `${day}-${month}-${year} ${hours}:${minutes}:${formattedSeconds}`;
  }

  const [backBtnText, setBackBtnText] = useState<string>('');

  const account = summaryData?.data;
  const isVerified = !!(account?.verified || account?.dateVerified);

  const navigateToAccountsPage = () => {
    if (summaryData?.data?.dateVerified === null) {
      navigate(`/general-list/${operatorId}/operatorcpe/Total Unverified Accounts Managed`);
    } else {
      navigate(`/general-list/${operatorId}/operatorcpe/Total Accounts Managed`);
    }
  };
 
  return (
    <div className="bd cp-page" data-theme={props.darkMode ? 'dark' : 'light'} data-accent="mint">
      <section id="cpe-details" className="cp-wrap">
        {backBtnText && (
          <button type="button" className="bd-pill cp-back" onClick={navigateToAccountsPage}>
            <ArrowLeft size={15} />
            {t(backBtnText)}
          </button>
        )}

        <header className="cp-hd">
          <span className="cp-hd-icon">
            <Router size={24} strokeWidth={1.75} />
          </span>
          <div className="bd-page-hd cp-hd-text">
            <span className="bd-eyebrow">{t('cpeDetails.header.eyebrow')}</span>
            <h1 className="bd-h1 bd-page-title">
              {account?.registrant || <span className="cp-title-placeholder">{t('cpeDetails.header.loadingAccount')}</span>}
            </h1>
            <span className="bd-body">{t('cpeDetails.header.subtitle')}</span>
          </div>
        </header>

        {account && (
          <div className="cp-facts">
            <span className={`bd-chip ${isVerified ? 'mint' : 'warn'}`}>
              <span className="dot" />
              {isVerified ? t('cpeDetails.facts.verified') : t('cpeDetails.facts.pendingVerification')}
            </span>
            {account.shield_active !== undefined && (
              <span className={`bd-chip ${account.shield_active ? 'mint' : 'warn'}`}>
                {account.shield_active ? <ShieldCheck size={12} /> : <ShieldOff size={12} />}
                {account.shield_active ? t('cpeDetails.facts.shieldActive') : t('cpeDetails.facts.shieldInactive')}
              </span>
            )}
            {account.last_seen && (
              <span className="bd-chip">
                <Clock size={12} />
                <Trans
                  i18nKey="cpeDetails.facts.lastSeen"
                  values={{ value: String(account.last_seen) }}
                  components={{ mono: <span className="bd-mono" /> }}
                />
              </span>
            )}
            <span className="bd-tag cp-tag">CPE {cpeId}</span>
            {account.serial && <span className="bd-tag cp-tag">SN {account.serial}</span>}
            {account.firmwareVersion && <span className="bd-tag cp-tag">FW {account.firmwareVersion}</span>}
            {account.mac && <span className="bd-tag cp-tag">MAC {account.mac}</span>}
          </div>
        )}

<div className="cp-body">
  {/* Tabs Navigation */}
  <div className="bd-tabbar cp-tabs" role="tablist" aria-label={t('cpeDetails.tabs.ariaLabel')}>
    {menuList.map((item) => {
      const Icon = tabIcons[item] || Info;
      const active = selectedMenu === item;
      return (
        <button
          key={item}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => handleMenuClick(item)}
          className={`bd-tabbar-item ${active ? 'active' : ''}`}
        >
          <Icon size={16} strokeWidth={1.9} />
          <span>{tabLabelKeys[item] ? t(tabLabelKeys[item]) : item}</span>
        </button>
      );
    })}
  </div>

  {/* Tab Content Container */}
  <div className="tab-content">
    {summaryData && (
      <>
        {/* Details Tab */}
        {selectedMenu === 'Details' && (
          <div className="bd-card cp-panel">
            <div className="cp-panel-body">
              <DetailsCpe
                summaryData={summaryData?.data}
                onTabSelect={handleMenuClick}
                emailSuccess={setEmailSuccess}
              />
            </div>
          </div>
        )}

        {/* Routers Tab */}
        {selectedMenu === 'Routers' && (
          <div className="bd-card cp-panel">
            <div className="cp-panel-body">
              <RoutersCpe summaryData={summaryData?.data} />
            </div>
          </div>
        )}

        {/* Devices Tab */}
        {selectedMenu === 'Devices' && (
          <div className="bd-card cp-panel">
            <div className="cp-panel-body">
              <DevicesCpe summaryData={summaryData} isActive={props.isActive} />
            </div>
          </div>
        )}

        {/* Mobiles Tab */}
        {selectedMenu === 'Mobiles' && (
          <div className="bd-card cp-panel">
            <div className="cp-panel-body">
              <MobilesCpe summaryData={summaryData} />
            </div>
          </div>
        )}

        {/* Threats Tab */}
        {selectedMenu === 'Threats' && (
          <div className="bd-card cp-panel">
            <div className="cp-panel-body">
              <ThreatsByType darkMode={props.darkMode} />
            </div>
          </div>
        )}

        {/* Activity Tab */}
        {selectedMenu === 'Activity' && (
          <div className="cp-panel flush">
            <div>
              <RouterActivity summaryData={summaryData} darkMode={props.darkMode} />
            </div>
          </div>
        )}

        {/* Settings Tab */}
        {selectedMenu === 'Settings' && (
          <div className="bd-card cp-panel">
            <div className="cp-panel-body">
              <RouterSettings summaryData={summaryData} />
            </div>
          </div>
        )}
        {selectedMenu === 'Call Logs' && (
          <div className="bd-card cp-panel">
            <div className="cp-panel-body">
              <CallLogs darkMode={props.darkMode}
              />
            </div>
          </div>
        )}
        {/* Scan Tab */}
        {selectedMenu === 'Scan' && (
          <div className="bd-card cp-panel">
            <div className="cp-panel-body">
              {/* Scan Header */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-br from-green-500 to-emerald-500 rounded-lg">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-white">
                      <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                        stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 8V12L14.5 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">{t('cpeDetails.scan.title')}</h3>
                    <p className="text-sm text-gray-500">{t('cpeDetails.scan.subtitle')}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <button
                    className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-green-500/25 flex items-center gap-2"
                    onClick={scanResults}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                        stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 8V12L14.5 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    {t('cpeDetails.scan.scanNow')}
                  </button>
                </div>
              </div>

              {/* Scan Results Section */}
              {loading && scanData && (
                <div className="space-y-6">
                  {/* Scan Info Card */}
                  <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-5 border border-blue-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <h4 className="font-semibold text-blue-800 mb-1">{t('cpeDetails.scan.infoTitle')}</h4>
                        <div className="flex items-center gap-4 text-sm text-blue-700">
                          <span className="flex items-center gap-1">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                              <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                                stroke="currentColor" strokeWidth="2"/>
                              <path d="M12 8V12L14.5 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            {t('cpeDetails.scan.timestamp', { value: formatDate(scanData.timestamp) })}
                          </span>
                        </div>
                      </div>
                      <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-semibold">
                        {t('cpeDetails.scan.hostsScanned', { count: scanData.hosts.length })}
                      </div>
                    </div>
                  </div>

                  {/* Results Table */}
                  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                    <div className="p-4 border-b border-gray-100 bg-gray-50">
                      <h4 className="text-lg font-semibold text-gray-800">{t('cpeDetails.scan.resultsTitle')}</h4>
                      <p className="text-sm text-gray-500">{t('cpeDetails.scan.resultsSubtitle')}</p>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('cpeDetails.scan.columns.protocol')}</th>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('cpeDetails.scan.columns.port')}</th>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('cpeDetails.scan.columns.state')}</th>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('cpeDetails.scan.columns.service')}</th>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('cpeDetails.scan.columns.product')}</th>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('cpeDetails.scan.columns.version')}</th>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">{t('cpeDetails.scan.columns.cves')}</th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {scanData.hosts.map((entry: any) =>
                            entry.ports.map((port: any, index: number) => (
                              <tr key={index} className="hover:bg-gray-50 transition-colors">
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                  {getTdValue(port.protocol)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                  {getTdValue(port.id)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <span className={`px-2 py-1 text-xs rounded-full font-semibold ${
                                    port.state === 'open' ? 'bg-green-100 text-green-800' :
                                    port.state === 'closed' ? 'bg-red-100 text-red-800' :
                                    'bg-gray-100 text-gray-800'
                                  }`}>
                                    {getTdValue(port.state)}
                                  </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                  {getTdValue(port.service.name)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                  {getTdValue(port.service.product)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                  {getTdValue(port.service.version)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm">
                                  {port.service.cve_list && port.service.cve_list.length > 0 ? (
                                    <div className="flex flex-wrap gap-1">
                                      {port.service.cve_list.map((cve: any, cveIndex: number) => (
                                        <button
                                          key={cveIndex}
                                          onClick={() => handleCve(cve)}
                                          className="px-2 py-1 bg-orange-100 text-orange-800 hover:bg-orange-200 rounded text-xs font-medium transition-colors"
                                        >
                                          {cve.cve_id}
                                        </button>
                                      ))}
                                    </div>
                                  ) : (
                                    <span className="text-gray-400 text-xs">{t('cpeDetails.scan.noCves')}</span>
                                  )}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {/* CVE Detail Modal */}
              {isClicked && cveData && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-2xl shadow-2xl w-11/12 max-w-2xl overflow-hidden">
                    {/* Modal Header */}
                    <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-orange-50 to-red-50">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="p-2 bg-gradient-to-br from-orange-500 to-red-500 rounded-lg">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-white">
                              <path d="M12 9V13M12 17H12.01M10.2679 4L3.33975 16C2.56995 17.3333 3.53216 19 5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0377 2.66667 10.2679 4Z"
                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                          <div>
                            <h3 className="text-xl font-bold text-gray-900">{cveData.cve_id}</h3>
                            <p className="text-sm text-gray-600">{t('cpeDetails.scan.cveSubtitle')}</p>
                          </div>
                        </div>
                        <button
                          onClick={() => setIsClicked(false)}
                          className="text-gray-400 hover:text-gray-600 transition-colors"
                        >
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                        </button>
                      </div>
                    </div>

                    {/* Modal Content */}
                    <div className="p-6 space-y-6">
                      {/* Score Card */}
                      <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl p-5 border border-gray-200">
                        <div className="flex items-center justify-between">
                          <div>
                            <h4 className="font-semibold text-gray-800 mb-1">{t('cpeDetails.scan.nistBaseScore')}</h4>
                            <p className="text-sm text-gray-600">{t('cpeDetails.scan.severityRating')}</p>
                          </div>
                          <div className="text-right">
                            <div className="text-3xl font-bold text-gray-900">{cveData.score}</div>
                            <div className="text-sm text-gray-600">{t('cpeDetails.scan.outOf')}</div>
                          </div>
                        </div>
                      </div>

                      {/* Details Grid */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-4">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-blue-600">
                                <path d="M12 16V12M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                              </svg>
                              {t('cpeDetails.scan.description')}
                            </h5>
                            <p className="text-gray-600 bg-gray-50 p-3 rounded-lg border border-gray-200">
                              {cveData.description}
                            </p>
                          </div>
                          
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-green-600">
                                <path d="M16 2V6M8 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z"
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                              </svg>
                              {t('cpeDetails.scan.publishedDate')}
                            </h5>
                            <p className="text-gray-600 bg-gray-50 p-3 rounded-lg border border-gray-200">
                              {cveData.published}
                            </p>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-red-600">
                                <path d="M12 9V13M12 17H12.01M10.2679 4L3.33975 16C2.56995 17.3333 3.53216 19 5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0377 2.66667 10.2679 4Z"
                                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {t('cpeDetails.scan.requiredAction')}
                            </h5>
                            <p className="text-gray-600 bg-gray-50 p-3 rounded-lg border border-gray-200">
                              {cveData.required_action}
                            </p>
                          </div>
                          
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="text-purple-600">
                                <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {t('cpeDetails.scan.sourceLink')}
                            </h5>
                            <a 
                              href={cveData.source} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:text-blue-800 hover:underline bg-blue-50 p-3 rounded-lg border border-blue-200 block break-all"
                            >
                              {cveData.source}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="p-6 border-t border-gray-200 bg-gray-50">
                      <div className="flex justify-end">
                        <button
                          onClick={() => setIsClicked(false)}
                          className="px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-semibold rounded-lg transition-all duration-200 hover:shadow-lg"
                        >
                          {t('cpeDetails.scan.closeDetails')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </>
    )}
  </div>
</div>
      </section>
    </div>
  );
};
  